{
  "actions": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "confirm": "Confirmar"
  },
  "status": {
    "loading": "Cargando…"
  },
  "nav": {
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú",
    "menuTitle": "Menú"
  }
}
